// AI-CONTEXT: See docs/patterns.md#data-taxonomy

// ─── Enums ───────────────────────────────────────────────────────────────────

export const activityTypes = [
  'guidance_support',
  'trajectory_programme',
  'training_education',
  'social_contact_group_activity',
  'sport_culture_leisure',
  'work_participation_development',
  'practical_service_provision',
  'production_workshop_making',
  'network_collaboration_community',
  'organisation_research_policy_communication',
  'other',
]

export const activitySubtypesByType = {
  guidance_support: [
    'individual_guidance',
    'coaching',
    'jobcoaching',
    'mental_health_coaching',
    'psychosocial_support',
    'practical_support',
    'intake',
    'referral',
    'aftercare',
    'workplace_guidance',
    'coaching_on_the_job',
    'group_guidance',
    'volunteer_guidance',
    'professional_guidance',
  ],
  trajectory_programme: [
    'development_trajectory',
    'reintegration_trajectory',
    'activation_trajectory',
    'work_learning_trajectory',
    'education_trajectory',
    'health_programme',
    'mentor_programme',
    'buddy_trajectory',
    'buddy_programme',
    'participation_programme',
    'empowerment_programme',
    'behaviour_change_programme',
    'prevention_programme',
    'aftercare_trajectory',
    'pre_trajectory',
    'pilot_programme',
    'community_programme',
  ],
  training_education: [
    'training',
    'workshop',
    'course',
    'lesson',
    'vocational_training',
    'schooling',
    'guest_lecture',
    'information_session',
    'knowledge_session',
    'masterclass',
    'train_the_trainer',
    'e_learning',
    'online_training',
    'practical_education',
    'skills_training',
    'lecture',
    'instruction_session',
  ],
  social_contact_group_activity: [
    'group_meeting',
    'peer_support',
    'conversation_group',
    'theme_meeting',
    'social_meeting',
    'meeting_activity',
    'drop_in_activity',
    'living_room_activity',
    'social_network_meeting',
    'community_meeting',
    'dialogue_meeting',
    'reflection_meeting',
    'story_meeting',
    'informal_meeting',
  ],
  sport_culture_leisure: [
    'sport_activity',
    'exercise_activity',
    'sport_training',
    'sport_event',
    'creative_workshop',
    'art_activity',
    'music_activity',
    'theatre_activity',
    'cultural_activity',
    'gaming_activity',
    'recreational_activity',
    'dance_activity',
    'play_activity',
    'leisure_activity',
    'cultural_event',
    'festival',
  ],
  work_participation_development: [
    'job_orientation',
    'career_guidance',
    'internship',
    'work_experience',
    'job_placement',
    'job_creation',
    'work_supervision',
    'employer_outreach',
    'entrepreneur_support',
    'reintegration_support',
    'participation_support',
    'talent_development',
    'training_placement',
    'volunteer_work',
    'social_participation',
  ],
  practical_service_provision: [
    'helpline',
    'information_provision',
    'advisory_service',
    'referral_service',
    'material_provision',
    'financial_support',
    'digital_service',
    'online_platform',
    'community_platform',
    'meeting_facility',
    'facility_management',
    'demand_supply_platform',
    'consultation_hour',
    'service_desk',
  ],
  production_workshop_making: [
    'production',
    'studio_activity',
    'workshop_activity',
    'craft_activity',
    'creative_production',
    'food_production',
    'hospitality_activity',
    'circular_production',
    'repair_reuse',
    'construction_activity',
    'technical_production',
    'agriculture_cultivation',
    'sustainable_production',
    'assembly',
  ],
  network_collaboration_community: [
    'network_event',
    'stakeholder_consultation',
    'coalition_building',
    'partner_development',
    'community_building',
    'collaboration_project',
    'chain_development',
    'matchmaking',
    'knowledge_sharing',
    'collaboration_session',
    'intervision',
    'learning_circle',
  ],
  organisation_research_policy_communication: [
    'research',
    'data_analysis',
    'impact_measurement',
    'monitoring',
    'evaluation',
    'policy_development',
    'policy_implementation',
    'organisational_development',
    'quality_improvement',
    'process_facilitation',
    'innovation',
    'product_development',
    'strategy_development',
    'communication',
    'pr_marketing',
    'fundraising',
    'advisory_consultancy',
    'knowledge_development',
    'publication',
  ],
  other: ['other'],
}

export const deliveryModes = [
  'individual',
  'group',
  'community',
  'organizational',
  'digital',
  'hybrid',
  'open_access',
]

export const intensityTypes = [
  'single_session',
  'recurring',
  'multi_session',
  'time_bound_trajectory',
  'continuous',
  'event_based',
]

export const estimatedEffortTypes = [
  'low',
  'medium',
  'high',
]

export const outputUnits = [
  'sessions',
  'participants',
  'meetings',
  'workshops',
  'lessons',
  'trajectories',
  'weeks',
  'events',
  'placements',
  'products',
  'users',
  'matches',
  'projects',
]

// ─── Default deliveryMode per subtype ────────────────────────────────────────

export const defaultDeliveryModeBySubtype = {
  // guidance_support
  individual_guidance: 'individual',
  coaching: 'individual',
  jobcoaching: 'individual',
  mental_health_coaching: 'individual',
  psychosocial_support: 'individual',
  practical_support: 'individual',
  intake: 'individual',
  referral: 'individual',
  aftercare: 'individual',
  workplace_guidance: 'individual',
  coaching_on_the_job: 'individual',
  group_guidance: 'group',
  volunteer_guidance: 'individual',
  professional_guidance: 'group',
  // trajectory_programme
  development_trajectory: 'individual',
  reintegration_trajectory: 'individual',
  activation_trajectory: 'individual',
  work_learning_trajectory: 'individual',
  education_trajectory: 'individual',
  health_programme: 'group',
  mentor_programme: 'individual',
  buddy_trajectory: 'individual',
  buddy_programme: 'individual',
  participation_programme: 'group',
  empowerment_programme: 'group',
  behaviour_change_programme: 'individual',
  prevention_programme: 'group',
  aftercare_trajectory: 'individual',
  pre_trajectory: 'individual',
  pilot_programme: 'group',
  community_programme: 'community',
  // training_education
  training: 'group',
  workshop: 'group',
  course: 'group',
  lesson: 'group',
  vocational_training: 'group',
  schooling: 'group',
  guest_lecture: 'group',
  information_session: 'group',
  knowledge_session: 'group',
  masterclass: 'group',
  train_the_trainer: 'group',
  e_learning: 'digital',
  online_training: 'digital',
  practical_education: 'group',
  skills_training: 'group',
  lecture: 'group',
  instruction_session: 'group',
  // social_contact_group_activity
  group_meeting: 'group',
  peer_support: 'group',
  conversation_group: 'group',
  theme_meeting: 'group',
  social_meeting: 'open_access',
  meeting_activity: 'open_access',
  drop_in_activity: 'open_access',
  living_room_activity: 'open_access',
  social_network_meeting: 'open_access',
  community_meeting: 'community',
  dialogue_meeting: 'group',
  reflection_meeting: 'group',
  story_meeting: 'group',
  informal_meeting: 'open_access',
  // sport_culture_leisure
  sport_activity: 'group',
  exercise_activity: 'group',
  sport_training: 'group',
  sport_event: 'open_access',
  creative_workshop: 'group',
  art_activity: 'group',
  music_activity: 'group',
  theatre_activity: 'group',
  cultural_activity: 'group',
  gaming_activity: 'group',
  recreational_activity: 'group',
  dance_activity: 'group',
  play_activity: 'group',
  leisure_activity: 'open_access',
  cultural_event: 'open_access',
  festival: 'open_access',
  // work_participation_development
  job_orientation: 'individual',
  career_guidance: 'individual',
  internship: 'individual',
  work_experience: 'individual',
  job_placement: 'individual',
  job_creation: 'organizational',
  work_supervision: 'individual',
  employer_outreach: 'organizational',
  entrepreneur_support: 'individual',
  reintegration_support: 'individual',
  participation_support: 'individual',
  talent_development: 'individual',
  training_placement: 'individual',
  volunteer_work: 'individual',
  social_participation: 'community',
  // practical_service_provision
  helpline: 'digital',
  information_provision: 'open_access',
  advisory_service: 'individual',
  referral_service: 'individual',
  material_provision: 'individual',
  financial_support: 'individual',
  digital_service: 'digital',
  online_platform: 'digital',
  community_platform: 'digital',
  meeting_facility: 'open_access',
  facility_management: 'organizational',
  demand_supply_platform: 'digital',
  consultation_hour: 'open_access',
  service_desk: 'open_access',
  // production_workshop_making
  production: 'group',
  studio_activity: 'group',
  workshop_activity: 'group',
  craft_activity: 'group',
  creative_production: 'group',
  food_production: 'group',
  hospitality_activity: 'group',
  circular_production: 'community',
  repair_reuse: 'individual',
  construction_activity: 'group',
  technical_production: 'group',
  agriculture_cultivation: 'group',
  sustainable_production: 'community',
  assembly: 'group',
  // network_collaboration_community
  network_event: 'open_access',
  stakeholder_consultation: 'organizational',
  coalition_building: 'organizational',
  partner_development: 'organizational',
  community_building: 'community',
  collaboration_project: 'organizational',
  chain_development: 'organizational',
  matchmaking: 'organizational',
  knowledge_sharing: 'group',
  collaboration_session: 'group',
  intervision: 'group',
  learning_circle: 'group',
  // organisation_research_policy_communication
  research: 'organizational',
  data_analysis: 'organizational',
  impact_measurement: 'organizational',
  monitoring: 'organizational',
  evaluation: 'organizational',
  policy_development: 'organizational',
  policy_implementation: 'organizational',
  organisational_development: 'organizational',
  quality_improvement: 'organizational',
  process_facilitation: 'organizational',
  innovation: 'organizational',
  product_development: 'organizational',
  strategy_development: 'organizational',
  communication: 'digital',
  pr_marketing: 'digital',
  fundraising: 'organizational',
  advisory_consultancy: 'organizational',
  knowledge_development: 'organizational',
  publication: 'digital',
  // other
  other: 'individual',
}

// ─── Default estimatedEffort per subtype ─────────────────────────────────────

export const defaultEstimatedEffortBySubtype = {
  // guidance_support
  individual_guidance: 'medium',
  coaching: 'high',
  jobcoaching: 'high',
  mental_health_coaching: 'high',
  psychosocial_support: 'high',
  practical_support: 'medium',
  intake: 'low',
  referral: 'low',
  aftercare: 'medium',
  workplace_guidance: 'medium',
  coaching_on_the_job: 'high',
  group_guidance: 'medium',
  volunteer_guidance: 'medium',
  professional_guidance: 'medium',
  // trajectory_programme
  development_trajectory: 'high',
  reintegration_trajectory: 'high',
  activation_trajectory: 'high',
  work_learning_trajectory: 'high',
  education_trajectory: 'high',
  health_programme: 'medium',
  mentor_programme: 'high',
  buddy_trajectory: 'high',
  buddy_programme: 'high',
  participation_programme: 'medium',
  empowerment_programme: 'high',
  behaviour_change_programme: 'high',
  prevention_programme: 'medium',
  aftercare_trajectory: 'medium',
  pre_trajectory: 'medium',
  pilot_programme: 'medium',
  community_programme: 'medium',
  // training_education
  training: 'medium',
  workshop: 'low',
  course: 'medium',
  lesson: 'medium',
  vocational_training: 'high',
  schooling: 'high',
  guest_lecture: 'low',
  information_session: 'low',
  knowledge_session: 'low',
  masterclass: 'medium',
  train_the_trainer: 'medium',
  e_learning: 'low',
  online_training: 'medium',
  practical_education: 'high',
  skills_training: 'medium',
  lecture: 'low',
  instruction_session: 'low',
  // social_contact_group_activity
  group_meeting: 'low',
  peer_support: 'medium',
  conversation_group: 'medium',
  theme_meeting: 'low',
  social_meeting: 'low',
  meeting_activity: 'low',
  drop_in_activity: 'low',
  living_room_activity: 'low',
  social_network_meeting: 'low',
  community_meeting: 'low',
  dialogue_meeting: 'medium',
  reflection_meeting: 'medium',
  story_meeting: 'medium',
  informal_meeting: 'low',
  // sport_culture_leisure
  sport_activity: 'low',
  exercise_activity: 'low',
  sport_training: 'medium',
  sport_event: 'low',
  creative_workshop: 'low',
  art_activity: 'low',
  music_activity: 'low',
  theatre_activity: 'medium',
  cultural_activity: 'low',
  gaming_activity: 'low',
  recreational_activity: 'low',
  dance_activity: 'low',
  play_activity: 'low',
  leisure_activity: 'low',
  cultural_event: 'low',
  festival: 'low',
  // work_participation_development
  job_orientation: 'medium',
  career_guidance: 'medium',
  internship: 'high',
  work_experience: 'high',
  job_placement: 'high',
  job_creation: 'high',
  work_supervision: 'medium',
  employer_outreach: 'medium',
  entrepreneur_support: 'high',
  reintegration_support: 'high',
  participation_support: 'medium',
  talent_development: 'high',
  training_placement: 'high',
  volunteer_work: 'medium',
  social_participation: 'medium',
  // practical_service_provision
  helpline: 'low',
  information_provision: 'low',
  advisory_service: 'low',
  referral_service: 'low',
  material_provision: 'low',
  financial_support: 'low',
  digital_service: 'low',
  online_platform: 'medium',
  community_platform: 'medium',
  meeting_facility: 'low',
  facility_management: 'medium',
  demand_supply_platform: 'medium',
  consultation_hour: 'low',
  service_desk: 'low',
  // production_workshop_making
  production: 'medium',
  studio_activity: 'medium',
  workshop_activity: 'medium',
  craft_activity: 'medium',
  creative_production: 'medium',
  food_production: 'medium',
  hospitality_activity: 'medium',
  circular_production: 'high',
  repair_reuse: 'medium',
  construction_activity: 'high',
  technical_production: 'high',
  agriculture_cultivation: 'high',
  sustainable_production: 'high',
  assembly: 'medium',
  // network_collaboration_community
  network_event: 'low',
  stakeholder_consultation: 'low',
  coalition_building: 'medium',
  partner_development: 'medium',
  community_building: 'high',
  collaboration_project: 'high',
  chain_development: 'high',
  matchmaking: 'low',
  knowledge_sharing: 'low',
  collaboration_session: 'low',
  intervision: 'medium',
  learning_circle: 'medium',
  // organisation_research_policy_communication
  research: 'high',
  data_analysis: 'high',
  impact_measurement: 'high',
  monitoring: 'medium',
  evaluation: 'medium',
  policy_development: 'high',
  policy_implementation: 'high',
  organisational_development: 'high',
  quality_improvement: 'medium',
  process_facilitation: 'medium',
  innovation: 'high',
  product_development: 'high',
  strategy_development: 'high',
  communication: 'medium',
  pr_marketing: 'medium',
  fundraising: 'high',
  advisory_consultancy: 'medium',
  knowledge_development: 'high',
  publication: 'medium',
  // other
  other: 'medium',
}

// ─── Default outputUnit per subtype ──────────────────────────────────────────

export const defaultOutputUnitBySubtype = {
  // guidance_support
  individual_guidance: 'sessions',
  coaching: 'sessions',
  jobcoaching: 'sessions',
  mental_health_coaching: 'sessions',
  psychosocial_support: 'sessions',
  practical_support: 'sessions',
  intake: 'sessions',
  referral: 'sessions',
  aftercare: 'sessions',
  workplace_guidance: 'sessions',
  coaching_on_the_job: 'sessions',
  group_guidance: 'meetings',
  volunteer_guidance: 'sessions',
  professional_guidance: 'sessions',
  // trajectory_programme
  development_trajectory: 'trajectories',
  reintegration_trajectory: 'trajectories',
  activation_trajectory: 'trajectories',
  work_learning_trajectory: 'trajectories',
  education_trajectory: 'trajectories',
  health_programme: 'trajectories',
  mentor_programme: 'trajectories',
  buddy_trajectory: 'trajectories',
  buddy_programme: 'trajectories',
  participation_programme: 'trajectories',
  empowerment_programme: 'trajectories',
  behaviour_change_programme: 'trajectories',
  prevention_programme: 'trajectories',
  aftercare_trajectory: 'trajectories',
  pre_trajectory: 'trajectories',
  pilot_programme: 'projects',
  community_programme: 'projects',
  // training_education
  training: 'sessions',
  workshop: 'workshops',
  course: 'lessons',
  lesson: 'lessons',
  vocational_training: 'trajectories',
  schooling: 'lessons',
  guest_lecture: 'sessions',
  information_session: 'sessions',
  knowledge_session: 'sessions',
  masterclass: 'sessions',
  train_the_trainer: 'sessions',
  e_learning: 'users',
  online_training: 'sessions',
  practical_education: 'lessons',
  skills_training: 'sessions',
  lecture: 'sessions',
  instruction_session: 'sessions',
  // social_contact_group_activity
  group_meeting: 'meetings',
  peer_support: 'meetings',
  conversation_group: 'meetings',
  theme_meeting: 'meetings',
  social_meeting: 'meetings',
  meeting_activity: 'meetings',
  drop_in_activity: 'meetings',
  living_room_activity: 'meetings',
  social_network_meeting: 'meetings',
  community_meeting: 'meetings',
  dialogue_meeting: 'meetings',
  reflection_meeting: 'meetings',
  story_meeting: 'meetings',
  informal_meeting: 'meetings',
  // sport_culture_leisure
  sport_activity: 'sessions',
  exercise_activity: 'sessions',
  sport_training: 'sessions',
  sport_event: 'events',
  creative_workshop: 'workshops',
  art_activity: 'sessions',
  music_activity: 'sessions',
  theatre_activity: 'sessions',
  cultural_activity: 'sessions',
  gaming_activity: 'sessions',
  recreational_activity: 'sessions',
  dance_activity: 'sessions',
  play_activity: 'sessions',
  leisure_activity: 'sessions',
  cultural_event: 'events',
  festival: 'events',
  // work_participation_development
  job_orientation: 'sessions',
  career_guidance: 'sessions',
  internship: 'placements',
  work_experience: 'weeks',
  job_placement: 'placements',
  job_creation: 'placements',
  work_supervision: 'sessions',
  employer_outreach: 'matches',
  entrepreneur_support: 'sessions',
  reintegration_support: 'trajectories',
  participation_support: 'sessions',
  talent_development: 'trajectories',
  training_placement: 'placements',
  volunteer_work: 'placements',
  social_participation: 'participants',
  // practical_service_provision
  helpline: 'users',
  information_provision: 'users',
  advisory_service: 'sessions',
  referral_service: 'sessions',
  material_provision: 'products',
  financial_support: 'participants',
  digital_service: 'users',
  online_platform: 'users',
  community_platform: 'users',
  meeting_facility: 'meetings',
  facility_management: 'projects',
  demand_supply_platform: 'matches',
  consultation_hour: 'sessions',
  service_desk: 'sessions',
  // production_workshop_making
  production: 'products',
  studio_activity: 'products',
  workshop_activity: 'sessions',
  craft_activity: 'products',
  creative_production: 'products',
  food_production: 'products',
  hospitality_activity: 'products',
  circular_production: 'products',
  repair_reuse: 'products',
  construction_activity: 'projects',
  technical_production: 'products',
  agriculture_cultivation: 'products',
  sustainable_production: 'products',
  assembly: 'products',
  // network_collaboration_community
  network_event: 'events',
  stakeholder_consultation: 'meetings',
  coalition_building: 'projects',
  partner_development: 'matches',
  community_building: 'projects',
  collaboration_project: 'projects',
  chain_development: 'projects',
  matchmaking: 'matches',
  knowledge_sharing: 'sessions',
  collaboration_session: 'sessions',
  intervision: 'sessions',
  learning_circle: 'sessions',
  // organisation_research_policy_communication
  research: 'projects',
  data_analysis: 'projects',
  impact_measurement: 'projects',
  monitoring: 'projects',
  evaluation: 'projects',
  policy_development: 'projects',
  policy_implementation: 'projects',
  organisational_development: 'projects',
  quality_improvement: 'projects',
  process_facilitation: 'projects',
  innovation: 'projects',
  product_development: 'products',
  strategy_development: 'projects',
  communication: 'users',
  pr_marketing: 'users',
  fundraising: 'projects',
  advisory_consultancy: 'projects',
  knowledge_development: 'projects',
  publication: 'products',
  // other
  other: 'sessions',
}

// ─── Dutch labels ─────────────────────────────────────────────────────────────

export const activityTypeLabels = {
  guidance_support: 'Begeleiding en ondersteuning',
  trajectory_programme: 'Trajecten en programma’s',
  training_education: 'Training, scholing en educatie',
  social_contact_group_activity: 'Ontmoeting en groepsactiviteiten',
  sport_culture_leisure: 'Sport, cultuur en vrije tijd',
  work_participation_development: 'Werk en participatie',
  practical_service_provision: 'Praktische dienstverlening en voorzieningen',
  production_workshop_making: 'Productie en werkplaatsen',
  network_collaboration_community: 'Netwerk en samenwerking',
  organisation_research_policy_communication: 'Organisatie, onderzoek en beleid',
  other: 'Overig',
}

export const activitySubtypeLabels = {
  // guidance_support
  individual_guidance: 'Individuele begeleiding',
  coaching: 'Coaching',
  jobcoaching: 'Jobcoaching',
  mental_health_coaching: 'Mentale gezondheidscoaching',
  psychosocial_support: 'Psychosociale ondersteuning',
  practical_support: 'Praktische ondersteuning',
  intake: 'Intakegesprek',
  referral: 'Doorverwijzing (begeleiding)',
  aftercare: 'Nazorg',
  workplace_guidance: 'Begeleiding in werkomgeving',
  coaching_on_the_job: 'Coaching on the job',
  group_guidance: 'Groepsbegeleiding',
  volunteer_guidance: 'Begeleiding vrijwilligers',
  professional_guidance: 'Begeleiding professionals',
  // trajectory_programme
  development_trajectory: 'Ontwikkeltraject',
  reintegration_trajectory: 'Re-integratietraject',
  activation_trajectory: 'Activeringstraject',
  work_learning_trajectory: 'Werk- en leertraject',
  education_trajectory: 'Scholingstraject',
  health_programme: 'Gezondheidsprogramma',
  mentor_programme: 'Mentorprogramma',
  buddy_trajectory: 'Maatjestraject',
  buddy_programme: 'Buddyprogramma',
  participation_programme: 'Participatieprogramma',
  empowerment_programme: 'Empowermentprogramma',
  behaviour_change_programme: 'Gedragsveranderprogramma',
  prevention_programme: 'Preventieprogramma',
  aftercare_trajectory: 'Nazorgtraject',
  pre_trajectory: 'Voortraject',
  pilot_programme: 'Pilotprogramma',
  community_programme: 'Communityprogramma',
  // training_education
  training: 'Training',
  workshop: 'Workshop',
  course: 'Cursus',
  lesson: 'Les',
  vocational_training: 'Opleiding',
  schooling: 'Scholing',
  guest_lecture: 'Gastles',
  information_session: 'Voorlichting',
  knowledge_session: 'Kennissessie',
  masterclass: 'Masterclass',
  train_the_trainer: 'Train-de-trainer',
  e_learning: 'E-learning',
  online_training: 'Online training',
  practical_education: 'Praktijkonderwijs',
  skills_training: 'Vaardigheidstraining',
  lecture: 'Lezing',
  instruction_session: 'Instructiesessie',
  // social_contact_group_activity
  group_meeting: 'Groepsbijeenkomst',
  peer_support: 'Lotgenotencontact',
  conversation_group: 'Gespreksgroep',
  theme_meeting: 'Themabijeenkomst',
  social_meeting: 'Sociale bijeenkomst',
  meeting_activity: 'Ontmoetingsactiviteit',
  drop_in_activity: 'Inloopactiviteit',
  living_room_activity: 'Huiskameractiviteit',
  social_network_meeting: 'Netwerkbijeenkomst (sociaal)',
  community_meeting: 'Communitybijeenkomst',
  dialogue_meeting: 'Dialoogbijeenkomst',
  reflection_meeting: 'Reflectiebijeenkomst',
  story_meeting: 'Verhaalbijeenkomst',
  informal_meeting: 'Informele ontmoeting',
  // sport_culture_leisure
  sport_activity: 'Sportactiviteit',
  exercise_activity: 'Beweegactiviteit',
  sport_training: 'Sporttraining',
  sport_event: 'Sportevenement',
  creative_workshop: 'Creatieve workshop',
  art_activity: 'Kunstactiviteit',
  music_activity: 'Muziekactiviteit',
  theatre_activity: 'Theateractiviteit',
  cultural_activity: 'Culturele activiteit',
  gaming_activity: 'Gaming activiteit',
  recreational_activity: 'Recreatieve activiteit',
  dance_activity: 'Dansactiviteit',
  play_activity: 'Spelactiviteit',
  leisure_activity: 'Vrijetijdsactiviteit',
  cultural_event: 'Cultureel evenement',
  festival: 'Festival',
  // work_participation_development
  job_orientation: 'Werktoeleiding',
  career_guidance: 'Loopbaanbegeleiding',
  internship: 'Stage',
  work_experience: 'Werkervaringsplek',
  job_placement: 'Werkplaatsing',
  job_creation: 'Werkplekcreatie',
  work_supervision: 'Werkbegeleiding',
  employer_outreach: 'Werkgeversbenadering',
  entrepreneur_support: 'Ondernemersondersteuning',
  reintegration_support: 'Re-integratie ondersteuning',
  participation_support: 'Participatiebegeleiding',
  talent_development: 'Talentontwikkeling',
  training_placement: 'Opleidingsplaats',
  volunteer_work: 'Vrijwilligerswerk',
  social_participation: 'Maatschappelijke participatie',
  // practical_service_provision
  helpline: 'Hulplijn',
  information_provision: 'Informatievoorziening',
  advisory_service: 'Adviesdienst',
  referral_service: 'Doorverwijzing (loket)',
  material_provision: 'Materiële ondersteuning',
  financial_support: 'Financiële ondersteuning',
  digital_service: 'Digitale dienstverlening',
  online_platform: 'Online platform',
  community_platform: 'Community platform',
  meeting_facility: 'Ontmoetingsvoorziening',
  facility_management: 'Faciliteitbeheer',
  demand_supply_platform: 'Vraag- en aanbodplatform',
  consultation_hour: 'Spreekuur',
  service_desk: 'Loketfunctie',
  // production_workshop_making
  production: 'Productieactiviteit',
  studio_activity: 'Atelieractiviteit',
  workshop_activity: 'Werkplaatsactiviteit',
  craft_activity: 'Ambachtelijke activiteit',
  creative_production: 'Creatieve productie',
  food_production: 'Voedselproductie',
  hospitality_activity: 'Horeca-activiteit',
  circular_production: 'Circulaire productie',
  repair_reuse: 'Reparatie / hergebruik',
  construction_activity: 'Bouwactiviteit',
  technical_production: 'Technische productie',
  agriculture_cultivation: 'Landbouw / teelt',
  sustainable_production: 'Duurzame productie',
  assembly: 'Assemblage',
  // network_collaboration_community
  network_event: 'Netwerkbijeenkomst (samenwerking)',
  stakeholder_consultation: 'Stakeholderoverleg',
  coalition_building: 'Coalitievorming',
  partner_development: 'Partnerontwikkeling',
  community_building: 'Community building',
  collaboration_project: 'Samenwerkingsproject',
  chain_development: 'Ketenontwikkeling',
  matchmaking: 'Matchmaking',
  knowledge_sharing: 'Kennisdeling',
  collaboration_session: 'Samenwerkingssessie',
  intervision: 'Intervisie',
  learning_circle: 'Leerkring',
  // organisation_research_policy_communication
  research: 'Onderzoek',
  data_analysis: 'Data-analyse',
  impact_measurement: 'Impactmeting',
  monitoring: 'Monitoring',
  evaluation: 'Evaluatie',
  policy_development: 'Beleidsontwikkeling',
  policy_implementation: 'Beleidsimplementatie',
  organisational_development: 'Organisatieontwikkeling',
  quality_improvement: 'Kwaliteitsverbetering',
  process_facilitation: 'Procesbegeleiding',
  innovation: 'Innovatie',
  product_development: 'Productontwikkeling',
  strategy_development: 'Strategieontwikkeling',
  communication: 'Communicatie',
  pr_marketing: 'PR en marketing',
  fundraising: 'Fondsenwerving',
  advisory_consultancy: 'Advies / consultancy',
  knowledge_development: 'Kennisontwikkeling',
  publication: 'Publicatie',
  // other
  other: 'Overig',
}

// ─── Definitions ──────────────────────────────────────────────────────────────
// One sentence per type/subtype so the term means the same across organizations
// (ADR-009 principle 4, applied to activities per ADR-010).

export const activityTypeDefinitions = {
  guidance_support: 'Persoonlijke of groepsgewijze begeleiding en ondersteuning van deelnemers.',
  trajectory_programme: 'Een meerstaps traject of programma met een begin en een eind.',
  training_education: 'Kennis- en vaardigheidsoverdracht via training, scholing of educatie.',
  social_contact_group_activity: 'Ontmoeting en groepsactiviteiten gericht op sociaal contact.',
  sport_culture_leisure: 'Activiteiten rond sport, cultuur en vrije tijd.',
  work_participation_development: 'Toeleiding naar en ontwikkeling richting werk en participatie.',
  practical_service_provision: 'Praktische diensten en voorzieningen voor de doelgroep.',
  production_workshop_making: 'Maken en produceren in werkplaatsen, ateliers of productie.',
  network_collaboration_community: 'Netwerken, samenwerken en gemeenschapsopbouw.',
  organisation_research_policy_communication: 'Organisatie-, onderzoeks-, beleids- en communicatiewerk.',
  other: 'Een activiteit die niet onder de overige typen valt.',
}

export const activitySubtypeDefinitions = {
  // guidance_support
  individual_guidance: 'Eén-op-één begeleiding van een deelnemer.',
  coaching: 'Doelgerichte coaching gericht op persoonlijke groei of gedrag.',
  jobcoaching: 'Coaching gericht op het vinden en behouden van werk.',
  mental_health_coaching: 'Coaching gericht op mentale gezondheid en veerkracht.',
  psychosocial_support: 'Ondersteuning bij psychische en sociale problemen.',
  practical_support: 'Hulp bij praktische zaken zoals administratie en regelingen.',
  intake: 'Eerste gesprek om de situatie en hulpvraag in kaart te brengen.',
  referral: 'Doorverwijzen van een deelnemer naar een passende voorziening, als onderdeel van begeleiding.',
  aftercare: 'Begeleiding na afronding van een traject of activiteit.',
  workplace_guidance: 'Begeleiding van een deelnemer op de werkplek.',
  coaching_on_the_job: 'Coaching tijdens het uitvoeren van het werk.',
  group_guidance: 'Begeleiding van een groep deelnemers tegelijk.',
  volunteer_guidance: 'Begeleiding en ondersteuning van vrijwilligers.',
  professional_guidance: 'Begeleiding van professionals, bijv. via supervisie of coaching.',
  // trajectory_programme
  development_trajectory: 'Meerstaps traject gericht op persoonlijke ontwikkeling.',
  reintegration_trajectory: 'Traject gericht op terugkeer naar werk.',
  activation_trajectory: 'Traject om iemand in beweging en activiteit te krijgen.',
  work_learning_trajectory: 'Gecombineerd werk- en leertraject.',
  education_trajectory: 'Traject gericht op scholing of opleiding.',
  health_programme: 'Programma gericht op gezondheid en welzijn.',
  mentor_programme: 'Programma waarin een mentor een deelnemer begeleidt.',
  buddy_trajectory: 'Traject waarin een maatje een deelnemer ondersteunt.',
  buddy_programme: 'Programma met buddy-koppels rond een gezamenlijk doel.',
  participation_programme: 'Programma gericht op maatschappelijke participatie.',
  empowerment_programme: 'Programma gericht op zelfredzaamheid en eigen kracht.',
  behaviour_change_programme: 'Programma gericht op gedragsverandering.',
  prevention_programme: 'Programma gericht op het voorkomen van problemen.',
  aftercare_trajectory: 'Traject met nazorg na een hoofdtraject.',
  pre_trajectory: 'Voorbereidend traject vóór een hoofdtraject.',
  pilot_programme: 'Tijdelijk programma om een aanpak te beproeven.',
  community_programme: 'Programma gericht op een gemeenschap of wijk.',
  // training_education
  training: 'Training gericht op kennis of vaardigheden.',
  workshop: 'Korte, praktische werksessie rond een thema.',
  course: 'Meerdere lessen rond een samenhangend onderwerp.',
  lesson: 'Een enkele les.',
  vocational_training: 'Beroepsgerichte opleiding.',
  schooling: 'Scholing gericht op kennis of kwalificatie.',
  guest_lecture: 'Eenmalige les door een gastdocent.',
  information_session: 'Bijeenkomst om informatie te geven.',
  knowledge_session: 'Sessie om kennis te delen of te verdiepen.',
  masterclass: 'Verdiepende les door een expert.',
  train_the_trainer: 'Training om anderen te leren trainen.',
  e_learning: 'Digitale, zelfstandige leermodule.',
  online_training: 'Training die online wordt gegeven.',
  practical_education: 'Onderwijs gericht op de praktijk.',
  skills_training: 'Training van specifieke vaardigheden.',
  lecture: 'Voordracht voor een publiek.',
  instruction_session: 'Sessie met praktische instructies.',
  // social_contact_group_activity
  group_meeting: 'Bijeenkomst van een groep deelnemers.',
  peer_support: 'Onderling contact en steun tussen lotgenoten.',
  conversation_group: 'Groep die met elkaar in gesprek gaat.',
  theme_meeting: 'Bijeenkomst rond een specifiek thema.',
  social_meeting: 'Bijeenkomst gericht op sociaal contact.',
  meeting_activity: 'Activiteit gericht op ontmoeting.',
  drop_in_activity: 'Vrij toegankelijke inloopactiviteit.',
  living_room_activity: 'Laagdrempelige huiskameractiviteit.',
  social_network_meeting: 'Bijeenkomst om sociale netwerken te versterken.',
  community_meeting: 'Bijeenkomst van een gemeenschap of wijk.',
  dialogue_meeting: 'Bijeenkomst gericht op dialoog tussen deelnemers.',
  reflection_meeting: 'Bijeenkomst om samen terug te blikken en te reflecteren.',
  story_meeting: 'Bijeenkomst waarin deelnemers verhalen delen.',
  informal_meeting: 'Informele, ongeplande ontmoeting.',
  // sport_culture_leisure
  sport_activity: 'Activiteit gericht op sport.',
  exercise_activity: 'Activiteit gericht op bewegen.',
  sport_training: 'Begeleide sporttraining.',
  sport_event: 'Sportevenement.',
  creative_workshop: 'Workshop rond een creatieve vaardigheid.',
  art_activity: 'Activiteit rond beeldende kunst.',
  music_activity: 'Activiteit rond muziek.',
  theatre_activity: 'Activiteit rond theater.',
  cultural_activity: 'Culturele activiteit.',
  gaming_activity: 'Activiteit rond games.',
  recreational_activity: 'Ontspannende, recreatieve activiteit.',
  dance_activity: 'Activiteit rond dans.',
  play_activity: 'Activiteit rond spelen.',
  leisure_activity: 'Vrijetijdsactiviteit.',
  cultural_event: 'Cultureel evenement.',
  festival: 'Festival.',
  // work_participation_development
  job_orientation: 'Oriëntatie op werk en beroepskeuze.',
  career_guidance: 'Begeleiding bij loopbaankeuzes.',
  internship: 'Stage om werkervaring op te doen.',
  work_experience: 'Werkervaringsplek.',
  job_placement: 'Plaatsing op een betaalde baan.',
  job_creation: 'Het creëren van werkplekken.',
  work_supervision: 'Begeleiding tijdens het werk.',
  employer_outreach: 'Benaderen van werkgevers voor plekken.',
  entrepreneur_support: 'Ondersteuning van (startende) ondernemers.',
  reintegration_support: 'Ondersteuning bij terugkeer naar werk.',
  participation_support: 'Begeleiding richting maatschappelijke participatie.',
  talent_development: 'Ontwikkelen van talenten van deelnemers.',
  training_placement: 'Plaatsing op een opleidingsplek.',
  volunteer_work: 'Inzet als vrijwilliger.',
  social_participation: 'Deelname aan de samenleving.',
  // practical_service_provision
  helpline: 'Telefonische of digitale hulplijn.',
  information_provision: 'Het verstrekken van informatie.',
  advisory_service: 'Adviesdienst voor de doelgroep.',
  referral_service: 'Een dienst of loket dat mensen doorverwijst naar passende hulp.',
  material_provision: 'Het verstrekken van materialen of goederen.',
  financial_support: 'Financiële ondersteuning.',
  digital_service: 'Dienstverlening via digitale kanalen.',
  online_platform: 'Online platform met diensten of informatie.',
  community_platform: 'Online platform voor een gemeenschap.',
  meeting_facility: 'Ruimte of voorziening voor ontmoeting.',
  facility_management: 'Beheer van voorzieningen of een locatie.',
  demand_supply_platform: 'Platform dat vraag en aanbod koppelt.',
  consultation_hour: 'Spreekuur voor vragen of hulp.',
  service_desk: 'Loket voor vragen en dienstverlening.',
  // production_workshop_making
  production: 'Het produceren van goederen of producten.',
  studio_activity: 'Activiteit in een atelier of studio.',
  workshop_activity: 'Activiteit in een werkplaats.',
  craft_activity: 'Ambachtelijk maken.',
  creative_production: 'Het maken van creatieve producten.',
  food_production: 'Het produceren van voedsel.',
  hospitality_activity: 'Horeca- of gastvrijheidsactiviteit.',
  circular_production: 'Productie gericht op hergebruik en circulariteit.',
  repair_reuse: 'Repareren en hergebruiken van spullen.',
  construction_activity: 'Bouw- of constructieactiviteit.',
  technical_production: 'Technische productie of assemblage.',
  agriculture_cultivation: 'Landbouw of teelt.',
  sustainable_production: 'Duurzaam produceren.',
  assembly: 'Assembleren van producten of onderdelen.',
  // network_collaboration_community
  network_event: 'Bijeenkomst gericht op netwerken en samenwerking.',
  stakeholder_consultation: 'Overleg met betrokken partijen.',
  coalition_building: 'Het vormen van een coalitie rond een doel.',
  partner_development: 'Het ontwikkelen van partnerschappen.',
  community_building: 'Het opbouwen van een gemeenschap.',
  collaboration_project: 'Project in samenwerking met partners.',
  chain_development: 'Het ontwikkelen van een ketensamenwerking.',
  matchmaking: 'Het koppelen van partijen of personen.',
  knowledge_sharing: 'Het delen van kennis tussen partijen.',
  collaboration_session: 'Werksessie met samenwerkingspartners.',
  intervision: 'Gestructureerd leren met vakgenoten.',
  learning_circle: 'Groep die gezamenlijk leert rond een thema.',
  // organisation_research_policy_communication
  research: 'Onderzoek doen.',
  data_analysis: 'Het analyseren van data.',
  impact_measurement: 'Het meten van impact.',
  monitoring: 'Het volgen van voortgang of resultaten.',
  evaluation: 'Het evalueren van een activiteit of programma.',
  policy_development: 'Het ontwikkelen van beleid.',
  policy_implementation: 'Het uitvoeren van beleid.',
  organisational_development: 'Het ontwikkelen van de organisatie.',
  quality_improvement: 'Het verbeteren van kwaliteit.',
  process_facilitation: 'Het begeleiden van een proces.',
  innovation: 'Het ontwikkelen van vernieuwing.',
  product_development: 'Het ontwikkelen van een product of dienst.',
  strategy_development: 'Het ontwikkelen van strategie.',
  communication: 'Communicatie naar doelgroepen.',
  pr_marketing: 'PR en marketing.',
  fundraising: 'Het werven van fondsen.',
  advisory_consultancy: 'Het leveren van advies of consultancy.',
  knowledge_development: 'Het ontwikkelen van kennis.',
  publication: 'Het maken van een publicatie.',
  // other
  other: 'Een activiteit die niet onder de overige subtypes valt.',
}

export const deliveryModeLabels = {
  individual: 'Individueel',
  group: 'Groep',
  community: 'Community',
  organizational: 'Organisatie',
  digital: 'Digitaal',
  hybrid: 'Hybride',
  open_access: 'Vrij toegankelijk',
}

export const intensityTypeLabels = {
  single_session: 'Eenmalig',
  recurring: 'Terugkerend',
  multi_session: 'Meerdere sessies',
  time_bound_trajectory: 'Tijdgebonden traject',
  continuous: 'Doorlopend',
  event_based: 'Evenementgebonden',
}

export const estimatedEffortLabels = {
  low: 'Laag (bijv. eenmalig evenement of workshop)',
  medium: 'Middel (bijv. wekelijkse groep of cursus)',
  high: 'Hoog (bijv. coaching of traject)',
}

export const outputUnitLabels = {
  sessions: 'Sessies',
  participants: 'Deelnemers',
  meetings: 'Bijeenkomsten',
  workshops: 'Workshops',
  lessons: 'Lessen',
  trajectories: 'Trajecten',
  weeks: 'Weken',
  events: 'Evenementen',
  placements: 'Plaatsingen',
  products: 'Producten',
  users: 'Gebruikers',
  matches: 'Matches',
  projects: 'Projecten',
}

// ─── Descriptions ─────────────────────────────────────────────────────────────

export const activityTypeDescriptions = {
  guidance_support: 'Activities focused on direct, often one-on-one support to individuals aimed at improving personal functioning, wellbeing, or decision-making.',
  trajectory_programme: 'Structured, time-bound programmes consisting of multiple coordinated activities designed to achieve longer-term development or change for participants.',
  training_education: 'Activities aimed at transferring knowledge, skills, or competencies through structured learning formats.',
  social_contact_group_activity: 'Activities primarily aimed at fostering social interaction, connection, and peer support among participants.',
  sport_culture_leisure: 'Recreational activities focused on physical, creative, or cultural engagement contributing to wellbeing and participation.',
  work_participation_development: 'Activities aimed at improving access to, readiness for, or participation in paid or unpaid work.',
  practical_service_provision: 'Direct provision of tangible support or services that address immediate practical needs of individuals or households.',
  production_workshop_making: 'Activities where participants actively produce, repair, or create goods, often with a learning or social component.',
  network_collaboration_community: 'Activities aimed at building networks, partnerships, or strengthening community structures and collaboration.',
  organisation_research_policy_communication: 'Activities focused on knowledge generation, policy influence, professional development, or communication at an organisational or system level.',
  other: 'Activities that do not clearly fit into any of the predefined categories.',
}

export const activitySubtypeDescriptions = {
  // guidance_support
  individual_guidance: 'Personalized support focused on helping an individual navigate challenges or improve specific life domains.',
  coaching: 'Goal-oriented guidance focused on personal development, behavior change, or performance improvement.',
  jobcoaching: 'Support aimed specifically at obtaining, maintaining, or improving performance in employment.',
  psychosocial_support: 'Support addressing mental, emotional, or social wellbeing challenges.',
  practical_support: 'Hands-on assistance with daily life tasks such as administration, housing, or logistics.',
  intake: 'Initial assessment or conversation to determine needs, eligibility, or appropriate support pathways.',
  referral: 'Directing individuals to other services or organisations better suited to meet their needs.',

  // trajectory_programme
  development_trajectory: 'Structured pathway aimed at personal growth or skill development over a defined period.',
  reintegration_trajectory: 'Programme focused on returning individuals to the labour market or society after absence.',
  mentor_programme: 'Structured relationship where a more experienced person supports the development of a participant.',
  buddy_trajectory: 'Peer-based support trajectory pairing individuals for mutual support and guidance.',

  // training_education
  training: 'Structured session focused on developing specific skills or competencies.',
  workshop: 'Interactive, often short session combining learning with practical exercises.',
  course: 'Series of structured learning sessions delivered over time with a defined curriculum.',
  lesson: 'Single instructional session within a broader educational context.',
  train_the_trainer: 'Programme aimed at equipping participants to deliver training themselves.',
  information_session: 'Session primarily focused on providing information or raising awareness.',

  // social_contact_group_activity
  group_meeting: 'Organized gathering of participants for discussion, sharing, or coordination.',
  peer_support: 'Group setting where participants support each other based on shared experiences.',
  meeting_activity: 'Low-threshold activity designed to facilitate informal social interaction.',
  conversation_group: 'Structured group discussion aimed at dialogue, reflection, or exchange.',

  // sport_culture_leisure
  sport_activity: 'Physical activity aimed at exercise, health, or recreation.',
  creative_activity: 'Activity involving artistic or creative expression.',
  music_activity: 'Activity centered around making or experiencing music.',
  cultural_activity: 'Activity related to cultural participation or expression.',
  event: 'One-off or occasional gathering open to a broader audience, often with a social or cultural purpose.',

  // work_participation_development
  job_placement: 'Direct placement of an individual into a job position.',
  work_experience: 'Temporary work setting aimed at gaining skills and experience.',
  sheltered_employment: 'Work provided in a protected environment for individuals needing additional support.',
  labour_pool: 'System for matching available workers with opportunities across organisations.',

  // practical_service_provision
  home_support: 'Support provided at home to assist with daily living or household tasks.',
  transport: 'Provision or coordination of transportation for participants.',
  material_provision: 'Distribution of goods or materials to meet basic needs.',
  financial_support: 'Direct financial assistance or monetary support to individuals.',

  // production_workshop_making
  production: 'Structured activity focused on producing goods or products.',
  repair: 'Activity aimed at fixing or restoring items.',
  craft_workshop: 'Hands-on session where participants create items or learn making skills.',
  circular_project: 'Project focused on reuse, recycling, or sustainable production practices.',

  // network_collaboration_community
  network_event: 'Event aimed at connecting individuals or organisations within a network.',
  partnership: 'Structured collaboration between organisations to achieve shared goals.',
  community_initiative: 'Locally driven activity aimed at improving the community or neighbourhood.',
  volunteer_coordination: 'Organising, matching, and supporting volunteers within activities or organisations.',

  // organisation_research_policy_communication
  research: 'Systematic collection and analysis of data to generate insights.',
  policy_advice: 'Providing recommendations to influence policy or decision-making.',
  communication_campaign: 'Coordinated effort to inform, influence, or engage a target audience.',
  training_professionals: 'Training aimed at professionals to improve their knowledge or skills.',

  // other
  other: 'Activities that cannot be classified under existing subtypes.',
}

// ─── Validation ───────────────────────────────────────────────────────────────

export const validateActivity = (data) => {
  if (!data.activityName) return false
  if (!data.activityType) return false
  if (!data.activitySubtype) return false
  if (!activitySubtypesByType[data.activityType]?.includes(data.activitySubtype)) return false
  if (data.customTags && data.customTags.length > 10) return false
  return true
}

// ─── Processing pipeline ──────────────────────────────────────────────────────

/**
 * Prepare an activiteit-taxonomy write. Deliberately WITHOUT completeness
 * validation: the TOC-editor (NodeEditor) auto-saves per chip click, so
 * partial states (a Type click resets the subtype; Uitvoering/Intensiteit
 * before any type) are legal — a throw here makes every chip click silently
 * dead (inbox #73; same regression pattern as doelgroep bug #60/#63).
 * Completeness gating is the caller's job (the wizard gates its steps; use
 * validateActivity for an explicit strict check). Subtype defaults only fill
 * unset fields when a subtype IS chosen — partial input never invents values.
 * AI-CONTEXT: See docs/pitfalls.md#ui-strict-validator-kills-autosave
 *
 * @param {{activityName?: string, activityType?: string, activitySubtype?: string, deliveryMode?: string, estimatedEffort?: string, outputUnit?: string}} input
 * @returns {object} input with subtype defaults applied and updatedAt stamped
 */
export const processActivity = (input) => {
  const subtype = input.activitySubtype || ''

  return {
    ...input,
    outputUnit: input.outputUnit || (subtype && defaultOutputUnitBySubtype[subtype]) || '',
    deliveryMode: input.deliveryMode || (subtype && defaultDeliveryModeBySubtype[subtype]) || '',
    estimatedEffort: input.estimatedEffort || (subtype && defaultEstimatedEffortBySubtype[subtype]) || '',
    updatedAt: new Date(),
  }
}
